// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isEmptyString } from "@flip/XDL/Utilities";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

export const XngSetAuthenticatedDetfaultValues = (props: any) => {
    const state = props.getState();
    const session = getSession(state);
    const billTo = getCurrentBillToState(state).value;

    if (session.isAuthenticated) {
        const data: any = {};
        if (!isEmptyString(session.firstName)) {
            data.firstName = session.firstName;
        }
        if (!isEmptyString(session.lastName)) {
            data.lastName = session.lastName;
        }
        if (!isEmptyString(session.email)) {
            data.emailAddress = session.email;
        }

        if (billTo && billTo.companyName) {
            data.companyName = billTo.companyName;
        }

        Object.keys(data).forEach(key => {
            props.dispatch({
                type: "Components/ContactUsForm/SetFieldValue",
                key,
                value: data[key],
            });
        });
    }
};

addToEndOfChain(chain, XngSetAuthenticatedDetfaultValues);
